import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Auto-recover from stale chunk errors after a new deploy.
// When a dynamic import fails (old hashed file no longer exists),
// reload once to fetch the fresh index.html + new chunk hashes.
const RELOAD_KEY = "hpe_chunk_reload";
function handleChunkError(message?: string) {
  if (!message) return;
  const isChunkError =
    message.includes("Importing a module script failed") ||
    message.includes("Failed to fetch dynamically imported module") ||
    message.includes("error loading dynamically imported module");
  if (!isChunkError) return;
  try {
    if (sessionStorage.getItem(RELOAD_KEY)) return;
    sessionStorage.setItem(RELOAD_KEY, "1");
  } catch {
    /* ignore */
  }
  // Cache-bust the HTML so we get fresh chunk hashes, not a stale index.html.
  const url = new URL(window.location.href);
  url.searchParams.set("_r", Date.now().toString());
  window.location.replace(url.toString());
}
window.addEventListener("error", (e) => handleChunkError(e?.message));
window.addEventListener("unhandledrejection", (e) =>
  handleChunkError(e?.reason?.message || String(e?.reason || "")),
);
// Clear the guard once the app successfully mounts.
setTimeout(() => {
  try {
    sessionStorage.removeItem(RELOAD_KEY);
  } catch {
    /* ignore */
  }
}, 4000);

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
